module.exports = __webpack_public_path__ + "img/akz.af2fef4d.png";